import { EMPTY_STRING } from '@/data/constants/marketing';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { addToCartFetcher, BASE_ADD_2_CART_BODY } from '@/data/Content/Cart';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { TransactionErrorResponse } from '@/data/types/Basic';
import { ProductAvailabilityData } from '@/data/types/ProductAvailabilityData';
import { getAttrsByIdentifier } from '@/data/utils/mapProductDetailsData';
import { cartMutatorKeyMatcher } from '@/data/utils/mutatorKeyMatchers/cartMutatorKeyMatcher';
import { processError } from '@/data/utils/processError';
import { MouseEvent, useCallback, useContext } from 'react';
import { mutate } from 'swr';
export { getAttrsByIdentifier };

type Props = {
	partNumber: string;
	physicalStoreName?: string;
};

import {
	getProductDetails,
	useProductDetails as useProductDetailsCore,
} from '@/core/data/Content/ProductDetails';
import { useNotifications } from '@/data/Content/Notifications';
import { EventsContext } from '@/data/context/events';
export { getProductDetails };

export const useProductDetails = (props: Props) => {
	const { onAddToCart } = useContext(EventsContext);
	const { showSuccessMessage, notifyError } = useNotifications();
	const success = useLocalization('success-message');

	const coreValue = useProductDetailsCore(props);
	const { selection, availability, loginRequired, product, category } = coreValue;
	const { settings } = useSettings();
	const params = useExtraRequestParameters();

	const addSampleToCart = useCallback(
		async (event: MouseEvent<HTMLElement>) => {
			if (loginRequired()) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();
			const { sku, quantity } = selection;
			if (sku?.partNumber) {
				let avail: ProductAvailabilityData | undefined; // the availability of online or physical store
				avail = availability?.find((a) => a.status);
				if (!avail) {
					avail = availability?.find((a) => a.physicalStoreStatus);
				}

				const orderItem = {
					partNumber: sku.partNumber,
					quantity: '1',
					xitem_field1: '1',
				};

				const data = { ...BASE_ADD_2_CART_BODY, orderItem: [orderItem] };
				try {
					await addToCartFetcher(true)(settings?.storeId ?? '', {}, data, params);
					await mutate(cartMutatorKeyMatcher(EMPTY_STRING), undefined);
					// notification
					showSuccessMessage(success.ITEM_TO_CART.t([product?.name ?? '']), true);

					onAddToCart({
						gtm: {
							selection,
							category,
							quantity,
							orgName: '', // TODO: specify selected org-name
							orgId: '', // TODO: specify selected org
							storeName: settings.storeName,
							settings,
						},
					});

					scrollTo(0, 0);
				} catch (e) {
					notifyError(processError(e as TransactionErrorResponse));
				}
			}
		},
		[
			loginRequired,
			selection,
			availability,
			settings,
			params,
			showSuccessMessage,
			success.ITEM_TO_CART,
			product,
			onAddToCart,
			category,
			notifyError,
		]
	);

	return {
		...coreValue,
		addSampleToCart,
	};
};
